export default __webpack_public_path__ + "static/media/github-white-logo.51d36d13.svg";